import { Link } from 'react-router-dom'
import icon1 from '../../images/icon/sms-white.svg'
import icon2 from '../../images/icon/call-white.svg'
import icon3 from '../../images/icon/location.svg'
import icon4 from '../../images/icon/sms02.svg'
import Services from '../../api/service'

const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const SubmitHandler = (e) => {
    e.preventDefault()
}


const Footer = (props) => {
    return (
        <footer className="footer footer-style-two pt-200 bg_img pos-rel" style={{ backgroundColor: "#0c111d" }}>
            <div className="container">
                <div className="xb-footer pt-120">
                    <div className="footer-info ul_li_between">
                        <div className="info-item ul_li">
                            <div className="xb-item--icon">
                                <span><img src={icon1} alt="" /></span>
                            </div>
                            <div className="xb-item--holder">
                                <p className="xb-item--content">E-mail</p>
                                <h4 className="xb-item--title">oi@synapz.tech</h4>
                            </div>
                        </div>
                        <div className="info-item ul_li">
                            <div className="xb-item--icon clr-blue">
                                <span><img src={icon2} alt="" /></span>
                            </div>
                            <div className="xb-item--holder">
                                <p className="xb-item--content">Telefone</p>
                                <h4 className="xb-item--title"><a href="tel:+551926605380" style={{color: 'inherit', textDecoration: 'none'}}>+55 19 2660-5380</a></h4>
                            </div>
                        </div>
                        <div className="info-item ul_li">
                            <div className="xb-item--icon clr-sky">
                                <span><img src={icon3} alt="" /></span>
                            </div>
                            <div className="xb-item--holder">
                                <p className="xb-item--content">Nosso escritório</p>
                                <h4 className="xb-item--title">San Francisco, CA</h4>
                            </div>
                        </div>
                    </div>
                    <div className="footer-inner mt-70 mb-100 ul_li_between align-items-start">
                        <div className="sa-newslatter footer-widget">
                            <span className="xb-item--sub-title">Newsletter</span>
                            <p className="xb-item--content clr-white">Receba conteúdos exclusivos sobre agentes de IA e automação inteligente para transformar o seu negócio.</p>
                            <form className="xb-item--input_field pos-rel" onSubmit={SubmitHandler}>
                                <input type="email" name="gmail" id="text6" placeholder="Seu melhor e-mail" />
                                <div className="img"><img src={icon4} alt="" /></div>
                                <button type="submit" className="xb-item--btn"><i className="fas fa-paper-plane"></i></button>
                            </form>
                            <span className="xb-item--text">Ao continuar, você concorda com os <Link onClick={ClickHandler} to="/">Termos de Uso</Link> e a <Link onClick={ClickHandler} to="/">Política de Privacidade</Link>.</span>

                        </div>
                        {/* <div className="footer-widget">
                            <span className="xb-item--sub-title">Empresa</span>
                            <ul className="xb-item--holder list-unstyled">
                                <li className="xb-item--list"><Link onClick={ClickHandler} to="/about">Sobre nós</Link></li>
                                <li className="xb-item--list"><Link onClick={ClickHandler} to="/casestudy">Clientes</Link></li>
                            </ul>
                        </div> */}
                        <div className="footer-widget">
                            <span className="xb-item--sub-title">Serviços</span>
                            <ul className="xb-item--holder list-unstyled">
                                {Services.slice(0, 6).map((service, srv) => (
                                    <li key={srv} className='xb-item--list'>
                                        {service.title ?
                                            <Link onClick={ClickHandler} to="/">
                                                <span className="icon_list_text">
                                                    {service.title}
                                                </span>
                                            </Link>
                                            : ''}
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="footer-widget">
                            <span className="xb-item--sub-title">Setores</span>
                            <ul className="xb-item--holder list-unstyled">
                                <li className="xb-item--list"><Link onClick={ClickHandler} to="/">Provedores de Internet</Link></li>
                                <li className="xb-item--list"><Link onClick={ClickHandler} to="/">Escritórios e Prestadores de Serviço</Link></li>
                                <li className="xb-item--list"><Link onClick={ClickHandler} to="/">Consultorias e Agências</Link></li>
                                <li className="xb-item--list"><Link onClick={ClickHandler} to="/">E-commerces</Link></li>
                                <li className="xb-item--list"><Link onClick={ClickHandler} to="/">Indústrias</Link></li>
                                <li className="xb-item--list"><Link onClick={ClickHandler} to="/">Atendimento ao cliente</Link></li>
                            </ul>
                        </div>
                    </div>
                    <div className="footer-copyright mt-70 ul_li_between">
                        <p className="copyright mt-20">Feito com ❤️ por brasileiros apaixonados por IA.<br/>Copyright © {new Date().getFullYear()} <Link onClick={ClickHandler} to="/">Synapz</Link>. Todos os direitos reservados.</p>

                        <ul className="footer-link ul_li mt-20">
                            <li><span>Siga a Synapz :</span></li>
                            <li><a href="https://x.com/SynapzTech" target="_blank" rel="noopener noreferrer"><i className="fab fa-twitter"></i></a></li>
                            {/* <li><Link onClick={ClickHandler} to="/"><i className="fab fa-facebook-f"></i></Link></li> */}
                            <li><a href="https://www.linkedin.com/company/synapz-tech" target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin-in"></i></a></li>
                            <li><a href="https://www.instagram.com/synapz.tech/" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a></li>
                            {/* <li><Link onClick={ClickHandler} to="/"><i className="fab fa-youtube"></i></Link></li> */}
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer;